import { PublicEducator } from '@cademy-package/sdk-component-types';
import { useReducer } from 'react';

export type VoucherCheckoutState = {
    currentStep: 'recipientDetails' | 'buyerDetails' | 'payment' | 'confirmation';
    recipient: {
        firstName?: string;
        lastName?: string;
        email?: string;
    };
    buyer: {
        firstName?: string;
        lastName?: string;
        email?: string;
    };

    amount: number;
    message?: string;
    educator: PublicEducator;
    courseSlug?: string;

    sharingMethod: 'email' | 'pdf';

    voucherId?: string;
    code?: string;

    errors?: string[];
};

type RecipientDetailsFilled = {
    type: 'recipientDetailsFilled';
    payload: {
        amount: number;
        recipient: {
            firstName: string;
            lastName: string;
            email?: string;
        };
        message?: string;
        sharingMethod: 'email' | 'pdf' | 'postcard';
    };
};

type BuyerDetailsFilled = {
    type: 'buyerDetailsFilled';
    payload: {
        firstName: string;
        lastName: string;
        email: string;
        voucherId: string;
        code: string;
    };
};

type PaymentCompleted = {
    type: 'paymentCompleted';
};

export type VoucherCheckoutAction = RecipientDetailsFilled | BuyerDetailsFilled | PaymentCompleted;

export const useVoucherCheckoutState = (setupValues: {
    educator: PublicEducator;
    courseSlug?: string;
}) => {
    return useReducer(
        (
            state: VoucherCheckoutState,
            action: Partial<VoucherCheckoutState>
        ): VoucherCheckoutState => {
            return {
                ...state,
                ...action,
            };
        },
        {
            currentStep: 'recipientDetails',

            recipient: {
                firstName: '',
                lastName: '',
                email: '',
            },
            buyer: {
                firstName: '',
                lastName: '',
                email: '',
            },

            amount: 25,
            sharingMethod: 'email',
            educator: setupValues.educator,
            courseSlug: setupValues.courseSlug,

            voucherId: undefined,
            code: undefined,
        }
    );
};
